import { Box, Button, Typography } from "@mui/material";
import React from "react";
import Marquee from "react-fast-marquee";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const courses = [
  { name: "Job Ready Courses", icon: "../../assets/images/my.jpg" },
  { name: "RKCL(RS-CIT)", icon: "../../assets/images/my.jpg" },
  { name: "Web Development", icon: "../../assets/images/my.jpg" },
  { name: "RKCL(RS-CFA)", icon: "../../assets/images/my.jpg" },
  { name: "Tally ERP (GST Ready)", icon: "../../assets/images/my.jpg" },
  { name: "Typing", icon: "../../assets/images/my.jpg" },
  { name: "DCO", icon: "../../assets/images/my.jpg" },
  { name: "Digital Marketing", icon: "../../assets/images/my.jpg" },
  { name: "Website Design", icon: "../../assets/images/my.jpg" },
];

function Cta() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const marqueeRows = isXs ? 3 : 5;

  const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  return (
    <Box
      sx={{
        p: 4,
        backgroundColor: "#f5f5f5",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        flex: 1,
      }}
    >
      {/* Left Content */}
      <Box
        sx={{
          gap: "2rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          flex: 0.5,
        }}
      >
        <Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#333",
              textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
              textAlign: "center",
            }}
          >
            Ready to Boost your skills?
          </Typography>
          <Typography sx={{ textWrap: "wrap", textAlign: "center" }}>
            Sign up now and get access to our exclusive courses, workshops, and
            training programs.
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "2rem" }}>
          <Button
            variant="contained"
            sx={{
              bgcolor: "black",
              "&:hover": { bgcolor: "grey.800" },
              borderRadius: "22px",
            }}
            onClick={() => navigate("/get-started")}
          >
            Sign up
          </Button>
          <Button
            variant="outlined"
            sx={{ borderColor: "black", color: "black", borderRadius: "22px" }}
            onClick={() => navigate("/courses")}
          >
            Learn More
          </Button>
        </Box>
      </Box>

      {/* Right Side Marquee Courses */}
      <Box
        sx={{
          position: "relative",
          flex: 0.5,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          marginBlock: "0.8rem",
          padding: 2,
          backgroundColor: "white",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          borderRadius: "16px",
          gap: "0.8rem",
        }}
      >
        {[...Array(marqueeRows)].map((_, index) => (
          <Marquee
            key={index}
            direction={index % 2 === 0 ? "left" : "right"}
            gradient={false}
            speed={40}
          >
            {courses.map((course, i) => (
              <Box
                key={`${index}-${i}`}
                onClick={() => navigate("/admission")}
                sx={{
                  padding: 2,
                  overflow: "hidden",
                  marginLeft: 2,
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                  cursor: "pointer",
                  borderRadius: "22px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        fontFamily: "Anton",
                        color: getRandomColor(),
                      }}
                    >
                      {course.name}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Marquee>
        ))}
      </Box>
    </Box>
  );
}

export default Cta;
